import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, DateField, FlexRow, Grid, Header3Text, NumberField, TextField } from 'ui-toolkit/index';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

export interface ITaxCertificationDelinquencyProps {
  index: number;
  canDelete: boolean;
  onRemove: () => void;
  baseName: string;
}

export const TaxCertificationDelinquency: React.FC<ITaxCertificationDelinquencyProps> = ({
  index,
  onRemove,
  canDelete,
  baseName,
}) => {
  return (
    <>
      <FlexRow justifyContent={'space-between'}>
        <Header3Text>Tax Delinquency {index + 1}</Header3Text>
        {canDelete && (
          <Button
            type="button"
            intent="ghost"
            isInline
            onClick={onRemove}
            data-test-id={mergeTests(baseName, 'delete')}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        )}
      </FlexRow>
      <Grid columnCount={8}>
        <NumberField
          name={`${baseName}.taxYear`}
          data-test-id={`${baseName}.taxYear`}
          label="Tax Year"
          placeholder="Type here"
        />
        <TextField
          name={`${baseName}.installNumber`}
          data-test-id={`${baseName}.installNumber`}
          label="Install Number"
          placeholder="Type here"
        />
        <DateField
          name={`${baseName}.billingPeriodStart`}
          data-test-id={`${baseName}.billingPeriodStart`}
          label="Billing Period Start"
          placeholder="Type here"
        />
        <DateField
          name={`${baseName}.billingPeriodEnd`}
          data-test-id={`${baseName}.billingPeriodEnd`}
          label="Billing Period End"
          placeholder="Type here"
        />
        <NumberField
          name={`${baseName}.taxesBilledCents`}
          data-test-id={`${baseName}.taxesBilledCents`}
          label="Taxes Billed"
          placeholder="Type here"
          mode={'currency'}
          valueIsCents
        />
        <NumberField
          name={`${baseName}.taxesPaidCents`}
          data-test-id={`${baseName}.taxesPaidCents`}
          label="Taxes Paid"
          placeholder="Type here"
          mode={'currency'}
          valueIsCents
        />
        <DateField
          name={`${baseName}.dueDate`}
          data-test-id={`${baseName}.dueDate`}
          label="Due Date"
          placeholder="Type here"
        />
        <TextField
          name={`${baseName}.status`}
          data-test-id={`${baseName}.status`}
          label="Status"
          placeholder="Type here"
        />
      </Grid>
    </>
  );
};
